import { Group } from "../../model/domain/Group";
import { InvestedFund } from "./InvestedFund";

export class User {
  id = 0;
  name: string = null;
  email: string = null;
  userDocument: string = null;
  userName: string = null;
  passwordExpirationDate: Date = null;
  active = true;
  accountManagerId: number = null;
  isMaster = false;
  isExternalUser = true;
  isDistributor: boolean = false;
  lockoutEndDateUtc: Date = null;
  lockoutEnabled = false;

  groups: Group[] = null;
  groupNames: string = null;

  investedFund: InvestedFund[] = null;
}
